export enum PackagingRemittance {
    NotSpecified = 1,
    InhouseMissingAch = 2,
    OpoNotSpecified = 3,
    Complete = 5,
    Unknown = 99
}